define('comments',['session', 'socket', 'elements', 'button-disabler', 'tooltip-notifier'], function(session, socket, elements, buttonDisabler, tooltipNotifier) {
	function init() {
		// set click handler
		$('#comments').on('click', '.load-skipped-answers-button', onLoadSkippedAnswersClick);
		$('#comments').on('click', '.upvote-comment-button', onUpvoteCommentButtonClick);
		$('#comments').on('click', '.downvote-comment-button', onDownvoteCommentButtonClick);
		$('#comments').on('click', '.submit-answer-form', onAnswerFormSubmit);
		$('#comments').on('click', '.cancel-answer-form', onAnswerFormCancel);
		$('#comments').on('click', '.comment-answer-button', onAnswerFormOpen);
		$('#comments').on('click', '.subscription-button', onSubscriptionButtonClick);
		$('#comments').on('click', '.delete-comment-button', onDeleteButtonClick);
		$('#load-more-comments-button').click(onLoadMoreCommentsClick);
		$('#parent-comment-input').click(onParentCommentInputClick);
	}

	return {
		init: init
	};

	function onParentCommentInputClick() {
		var parentCommentSubmit = $('#parent-comment-sb');

		if (parentCommentSubmit.css('display') == 'none') {
			parentCommentSubmit.slideDown(300);
		}
	}

	function onLoadSkippedAnswersClick() {
		var button = $(this);

		buttonDisabler.disable(button);
		loadAnswers($(this).closest('.comment-thread')).fail(function() {
			buttonDisabler.enable(button);
			tooltipNotifier.showError(button, 'Fehler beim Laden der Antworten. Bitte erneut versuchen.');
		});
	}

	function loadAnswers(threadElement) {
		return $.get('/comments/' + threadElement.data('thread-id') + '/answers', function(response) {
			var answers = threadElement.find('.comment-answers');

			answers.html(response);
			elements.enable(answers);
		});
	}

	function onUpvoteCommentButtonClick() {
		vote($(this).hasClass('checked') ? 0 : 1, $(this).closest('.comment'));
	}

	function onDownvoteCommentButtonClick() {
		vote($(this).hasClass('checked') ? 0 : -1, $(this).closest('.comment'));
	}

	function vote(vote, comment) {
		if (!session.loggedIn) {
			return;
		}

		var upvoteButton = comment.find('.upvote-comment-button');
		var downvoteButton = comment.find('.downvote-comment-button');
		var commentID = comment.data('id');

		upvoteButton.prop('disabled', true);
		downvoteButton.prop('disabled', true);

		$.ajax({
			url: '/comments/' + commentID + '/vote',
			data: {
				vote: vote
			},
			type: 'POST',
			dataType: "json"
		}).done(function (votes) {
			upvoteButton.prop('disabled', false);
			downvoteButton.prop('disabled', false);

			// update votes
			var diff = votes.upvotes - votes.downvotes;
			if (diff == 0) {
				comment.find('.comment-votes').html("");
			} else if (diff > 0) {
				comment.find('.comment-votes').removeClass('down').addClass('up').html("+" + diff);
			} else if (diff < 0) {
				comment.find('.comment-votes').removeClass('up').addClass('down').html(diff);
			}

			upvoteButton.toggleClass('checked', vote == 1);
			downvoteButton.toggleClass('checked', vote == -1);
		}).fail(function (e) {
			tooltipNotifier.showError(downvoteButton, 'Fehler beim Bewerten des Kommentars. Bitte versuche es erneut.', e);
		}).always(function() {
			upvoteButton.prop('disabled', false);
			downvoteButton.prop('disabled', false);
		});
	}

	function onAnswerFormSubmit() {
		var form = $(this).closest('.answer-form');
		var input = form.find('textarea');
		var comment = input.val().trim();
		var button = $(this);
		var thread = $(this).closest('.comment-thread');
		var postID = thread.data('post-id');
		var threadID = thread.data('thread-id');

		if (!comment) {
			return;
		}

		buttonDisabler.disable(button);

		$.ajax({
			url: '/comments/reply',
			data: {
				thread_id: threadID,
				comment: comment
			},
			type: 'POST',
			dataType: "json"
		}).done(function(result) {
			loadAnswers(thread);
			input.val('');
			form.hide();

			// Has the user automatically been subscribed to the thread?
			if (result.hasSubscribed) {
				setSubscribed(thread, true);
			}
		}).fail(function(e) {
			tooltipNotifier.showError(button, 'Fehler beim Eintragen des Kommentars. Bitte versuche es erneut.', e);
		}).always(function() {
			buttonDisabler.enable(button);
		});
	}

	function onAnswerFormCancel() {
		var form = $(this).closest('.answer-form');
		form.hide();
	}

	function onAnswerFormOpen() {
		var comment = $(this).closest('.comment');
		var thread = comment.closest('.comment-thread');
		var form = thread.find('.answer-form');
		var textarea = form.find('textarea');
		var commentCreator = comment.data('creator');
		var replyTo = (comment.hasClass('answer') && commentCreator && commentCreator != session.user) ? commentCreator : null;

		form.show();
		textarea.focus();

		if (replyTo && !textarea.val()) {
			textarea.val('@' + replyTo + ': ');
		}
	}

	function onSubscriptionButtonClick() {
		var button = $(this);
		var action = button.hasClass('subscribe-button') ? 'subscribe' : 'unsubscribe';
		var thread = button.closest('.comment-thread');
		var threadID = thread.data('thread-id');

		buttonDisabler.disable(button);

		$.ajax({
			url: '/comments/' + threadID + '/' + action,
			type: 'POST',
			dataType: 'json'
		}).done(function() {
			setSubscribed(thread, action === 'subscribe');
			buttonDisabler.enable(button);
		}).fail(function(xhr) {
			var message = 'Fehler beim Abonnieren des Kommentars.';
			if (action === 'unsubscribe') {
				message = 'Fehler beim Beenden des Kommentar-Abonnements.';
			}
			tooltipNotifier.showError(button, message, xhr);
			buttonDisabler.enable(button);
		});
	}

	function setSubscribed(threadElement, subscribed) {
		var button = threadElement.find('.subscription-button');
		threadElement.data('subscribed', subscribed);
		button.toggleClass('subscribe-button');
		button.toggleClass('unsubscribe-button');
		button.text(subscribed ? 'Nicht mehr folgen' : 'Folgen')
	}

	function onLoadMoreCommentsClick() {
		var button = $(this);
		var postID = $('#comments').data('post-id');

		buttonDisabler.disable(button);

		$.ajax({
			url: '/comments/' + postID,
			type: 'GET',
			dataType: 'json',
			data: {
				last_comment_update: $('#comments').data('last-comment-update'),
				comment: $('#comments').data('thread-at-top-id')
			}
		}).done(function(data) {
			if (data.more_available)
				buttonDisabler.enable(button);
			else
				button.remove();

			var new_comment_elements = $.parseHTML(data.html);
			elements.enable(new_comment_elements);
			$('#comments').find('.comments-wrap').append(new_comment_elements);

			$('#comments').data('last-comment-update', data.last_comment_update);
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Beim Nachladen der Kommentare ist ein Fehler aufgetreten. Bitte versuche es erneut.', xhr);
			buttonDisabler.enable(button);
		});
	}

	function onDeleteButtonClick(e) {
		var button = $(this);
		var comment = button.closest('.comment');
		var commentID = comment.data('id');
		if (!confirm('Möchtest du diesen Kommentar wirklich löschen?')) {
			return;
		}

		$.ajax({
			url: '/comments/' + commentID + '/delete',
			type: 'POST',
			dataType: 'json'
		}).done(function() {
			if (comment.hasClass('answer')) {
				// load the thread new so deleted comments are replaced
				loadAnswers(comment.closest('.comment-thread'));
			} else {
				comment.closest('.comment-thread').remove();
			}
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Fehler beim Löschen des Kommentars', xhr);
		});
	}
});

